import { GA_CUSTOM_EVENTS } from './../_store/constants';
import { GACustomEventParams } from './../_store/types';
import { isProduction } from "@utils";
import exportPdf from './_exportPdf';

const logCustomGAEvent = (event: GA_CUSTOM_EVENTS, eventParams: GACustomEventParams | null) => {
  if (!window.gtag) {
    if (isProduction()) return;
    console.log(`[GA_CUSTOM_EVENT]: ${event}${eventParams ? ' -- ' + JSON.stringify(eventParams) : ''}`)
    return;
  };
  window.gtag('event', event, eventParams);
}

export {
  exportPdf,
  logCustomGAEvent
}